import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gu26ucey5v: FaireBrandEntity = {
  token: "b_gu26ucey5v",
  type: "brand",
  name: "Queen Fashion",
  avatarUrl:
    "https://cdn.faire.com/fastly/91011a42e42c326332add90472801459a3963a09c8410ff13a96cb46f733f42a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/db2f88b6cc010d02af51743d1b5caa260d7a2387a9045eed884573401ff29ebb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/91011a42e42c326332add90472801459a3963a09c8410ff13a96cb46f733f42a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/db2f88b6cc010d02af51743d1b5caa260d7a2387a9045eed884573401ff29ebb.png",
  location: "San Antonio, TX, USA",
  minimumOrderDollars: 100,
  rating: 3.7,
  reviewCount: 107,
  isInsider: true,
  description:
    "Queen Fashion is a women’s apparel brand focused on feminine silhouettes, statement styles, and elevated occasion wear designed for modern boutiques.\n\nOur collections highlight flattering cuts, confident shapes, and seasonal details — from dresses and jumpsuits to coordinated sets and standout tops — created to help women feel confident, polished, and empowered. Each style is thoughtfully developed to balance trend appeal with wearability, making it easy for boutiques to merchandise and sell.\n\nWe work closely with retail partners to support reliable sell-through, offering a clear mix of core styles and seasonal updates. In addition to our ready-to-order collections, we also support select custom graphic tees and sweatshirts for boutiques seeking fast-turn, small-batch programs.\n\nWith consistent quality standards, responsive production, and flexible order support, Queen Fashion is built to grow alongside our wholesale partners.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:59.744Z",
    importedBy: "entity-db-cli",
  },
};
